import { Component } from "react";
import { TimelineEvent } from "react-event-timeline";
import { formatDateTime } from "@app/shared";
import { ProjectionProviderHistoryType, ProjectionProviderType } from "../enumerators";
import { ProjectionProviderHistoryEntry } from "../results/projection-provider/projectionProviderHistory";

interface ProjectionProviderHistoryEntryProps {
  historyEntry: ProjectionProviderHistoryEntry;
}

const contentStyle = { fontSize: "100%", fontWeight: "normal" };
const iconStyle = { cursor: "default" };
const bubbleStyle = { background: "#fff", border: "none" };

export default class ProjectionProviderHistoryEntryDisplay extends Component<ProjectionProviderHistoryEntryProps> {
  constructor(props: ProjectionProviderHistoryEntryProps) {
    super(props);
  }

  public render() {
    const entry = this.props.historyEntry;
    const title = (this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Created || this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Cloned) ? "Created" : "Updated";
    const subtitile = this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Cloned ? "Copied from another project on " : "";

    return (
      <>
        <TimelineEvent
          key={`timelineEvent:${entry.historyEntryTime.valueOf()}`}
          icon={<i className={`fa fa-calendar fs22`} />}
          title={<span className="font-weight-bold">{`${title} by ${entry.userName} ${this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Cloned ? "" : "on"}`}</span>}
          subtitle={<span className="font-weight-bold">{`${subtitile}${formatDateTime(entry.historyEntryTime)}`}</span>}
          iconStyle={iconStyle}
          bubbleStyle={bubbleStyle}
          style={contentStyle}
          contentStyle={contentStyle}>
          <dl className="container timeline-container">
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="font-weight-bold">Projection Provider Type:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {ProjectionProviderHistoryEntryDisplay.projectionTypePastTense(entry.projectionProviderType)}
              </dd>
            </div>
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="font-weight-bold">Specialty Code:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.specialtyCode}
              </dd>
            </div>
            {entry.projectionProviderType == ProjectionProviderType.ExcludeImpact && < div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="font-weight-bold">Exclusion Verified Sources:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.exclusionVerifiedSources.join("; ")}
              </dd>
            </div>}
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="font-weight-bold">Reason:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.reasonName}
              </dd>
            </div>
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="font-weight-bold">Comment:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.reasonDescription}
              </dd>
            </div>
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="font-weight-bold">All Locations:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.allLocations ? <i className="fa fa-check" /> : <>&nbsp;</>}
              </dd>
            </div>
            {entry.projectionProviderType == ProjectionProviderType.ExcludeImpact && <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="font-weight-bold">All Projects:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.allProjects ? <i className="fa fa-check" /> : <>&nbsp;</>}
              </dd>
            </div>}
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="font-weight-bold">All Specialties:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.allSpecialties ? <i className="fa fa-check" /> : <>&nbsp;</>}
              </dd>
            </div>
          </dl>
        </TimelineEvent>
      </>
    );
  }

  private static projectionTypePastTense(projectionProviderType: ProjectionProviderType): string {
    switch (projectionProviderType) {
      case ProjectionProviderType.ExcludeImpact:
        return "Excluded";
      case ProjectionProviderType.Target:
        return "Targeted";
      case ProjectionProviderType.Unknown:
        return "Unknown";
    }
  }
}
